import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcInsertphoto(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.5 16.589-3.972-4.476-5.295 5.278a.95.95 0 0 1-1.341-.002l-2.35-2.35L4.5 16.931v1.819c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75zM10.25 9a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m9.25-3.75a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75v9.636l1.2-1.11.096-.08a1.25 1.25 0 0 1 1.545.03l.093.084 2.13 2.13 5.094-5.076.099-.089a1.25 1.25 0 0 1 1.625.05l.094.095 3.024 3.41zM11.75 9a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0M21 18.75A2.25 2.25 0 0 1 18.75 21H5.25A2.25 2.25 0 0 1 3 18.75V5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25z"
  }));
}
var IcInsertphoto = createNolIcon(/*#__PURE__*/forwardRef(SvgIcInsertphoto));

export { IcInsertphoto as I };
